import { defineComponent as _defineComponent } from 'vue'
import {useCacheStore} from "@/pinia";
import AccountAddress from "@/components/common/AccountAddress.vue";
import {computed} from "vue";

// props
interface IProps {
	address: string;
	large?: boolean;
	small?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformImage',
  props: {
    address: null,
    large: { type: Boolean },
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	address: string;
	large?: boolean;
	small?: boolean;
};



// store
const cacheStore = useCacheStore();


//computed

//TODO Replace this with an api call to get json
const imageSrc = computed<string>(() => {
	let img = '';
	switch (props.address) {
		case "JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4":
		case "JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB":
		case "JUP2jxvXaqu7NQY1GmNF4m1vodw12LVXYxbFL2uJvfo":
			img = "jupiter.png";
			break
		case "45ruCyfdRkWpRNGEqWzjCiXRHkZs8WXCLQ67Pnpye7Hp":
			// img = "ape_pro.png";
			img = "jupiter.png";
			break
		case "FLUXubRmkEi2q6K3Y9kBPg9248ggaZVsoSFhtJHSrm1X":
		case "FLUXR4McuD2iXyP3wpP4XTjSWmB86ppMiyoA52UA9bKb":
			img = "fluxbeam.png";
			break
		case "24Uqj9JCLxUeoC3hGfh5W3s9FM9uCHDS2SG3LYwBpyTi":
		case "Eo7WjKq67rjJQSZxS6z3YkapzY3eMj6Xy8X5EQVn5UaB":
		case "LBUZKhRxPF3XUpBCjp4YzTKgLccjZhTSDM9YuVaPwxo":
			img = "meteora.png";
			break
		case "5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1":
		case "675kPX9MHTjS2zt1qfr1NYHuzeLXfQM9H24wFSUt1Mp8":
		case "CAMMCzo5YL8w4VFF8KVHrK22GGUsp5VTaW7grrKgrWqK":
		case "CPMMoo8L3F4NbTegBCKVNunggL7H1ZpdTHKxQB5qKP1C":
			img = "raydium.png"
			break
		case "LanMV9sAd7wArD4vJFi2qDdfnVhFxYSUg6eADduJ3uj":
			img = "raydium_launchlab.png"
			break
		case "PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY":
			img = "phoenix.jpg"
			break
		case "2wT8Yq49kHgDzXuPxZSaeLaH1qbmGXtEyPy64bL7aD3c":
			img = "lifinity.jpg"
			break
		case "opnb2LAfJYbRMAHHvqjCwQxanZn7ReEHp1k81EohpZb":
			img = "openbook.png"
			break
		case "Gswppe6ERWKpUTXvRPfXdzHhiCyJvLadVvXGfdpBqcE1":
			img = "guac.png"
			break
		case "whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc":
			img = "orca.png"
			break
		case "obriQD1zbpyLz95G5n7nJe6a4DPjpFwa5XYPoNm113y":
			img = "obric.png"
			break
		case "swapNyd8XiQwJ6ianp9snpu4brUqFxadzvHebnAXjJZ":
			img = "stabble.png"
			break
		case "HyaB3W9q6XdA5xwpU4XnSZV94htfmbmqJXZcEbRaJutt":
			img = "invariant.png"
			break
		case "SSwpkEEcbUqx4vtoEByFjSkhKdCT862DNVb52nZg1UZ":
			img = "saber.png"
			break
		case "SoLFiHG9TfgtdUXUjWAxi3LtvYuFyDLVhBWxdMZxyCe":
			img = "solfi.jpg"
			break
		case "6EF8rrecthR5Dkzon8Nwu78hRvfCKubJ14M5uBEwF6P":
			img = "pump_fun.png"
			break
		case "pAMMBay6oceH9fJKBRHGP5D4bD4sWpmSwMn52FMfXEA":
			img = "pump_fun_amm.png"
			break
		case "FEESuLjQRGWbnBQMS25oo84UfZkZM4rrnuez6L3EMDu6":
			img = "nuts_fun.png"
			break
		case "MoonCVVNZFSYkqNXP6bxHLPL6QQJiMagDL3qcqUQTrG":
			img = "moonshot.png"
			break
		case "DEXYosS6oEGvk8uCDayvwEZz4qEyDJRf9nFgYCaqPMTm":
			img = "onedex.png"
			break
		case "HWEoBxYs7ssKuudEjzjmpfJVX7Dvi7wescFsVx2L5yoY":
			img = "bloxroute.png"
			break
		case "ZG98FUCjb8mJ824Gbs6RsgVmr1FhXb2oNiJHa2dwmPd":
			img = "bonkbot.jpg"
			break
		case "noVaE91mUL5jTb8e9Vf6dqJdNPzJpEQ3uAdnQ8h4nVz":
			img = "novabot.png"
			break
		case "9yMwSPk9mrXSN7yDHUuZurAh1sjbJsfpUqjZ7SvVtdco":
			img = "trojan.jpg"
			break
		case "4o9p5PaYQcfNiLZCCN5ZsZckdtj6Up3xzLvSoZx8GufA":
		case "28KqHiudrpzfVkVWQ1jztQ2Aarf4W3CvTitjWEqTCkpA":
			img = "bullx.png"
			break
		case "BB5dnY55FXS1e1NXqZDwCzgdYJdMCj3B92PU6Q5Fb6DT":
			img = "gmgn.png"
			break
		case "4uks6GfvhLaqJxWrZZYYxfbU24Kz7318VLXQozKQav6V":
		case "AVUCZyuT35YSuj4RH7fwiyPu82Djn2Hfg7y2ND2XcnZH":
			img = "photon.png"
			break
		case "SNaPnpKUY656VPwbKmKT8FG4T85g4VWhRH1B4TQUfKs":
			img = "snapper.png"
			break
	}

	if (img === '')
		return ""

	return `https://api.fluxbeam.xyz/public/amms/${img}`
});

return { __sfc: true,props, cacheStore, imageSrc, AccountAddress }
}

})